import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { initialize, reduxForm, Field } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import M from 'materialize-css';

import FormButton from '../../components/UI/FormButton';
import { 
    renderFieldTwoColumns 
} from '../../components/UI/Fileds';

import { setDocumentFilter } from '../../actions/document';

const DocumentSearchForm = ({ submitting, handleSubmit }) => {

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { filter } = useSelector(state => state.document);

    useEffect(() => {

        const elems = document.querySelectorAll('.collapsible');
        M.Collapsible.init(elems, {});
        
        dispatch(
            initialize('documentSearchForm', filter)
        );

    }, [dispatch, filter]);
    
    const handleReset = () => {
        dispatch(
            setDocumentFilter({})
        );
    };

    const handleSearch = (values) => {
        const collapsibles = document.getElementsByClassName('collapsible-search-form');
        const instance = M.Collapsible.getInstance(collapsibles[0]);
        instance.close();

        dispatch(setDocumentFilter(values));
    }

    const renderForm = () => {
        return (
            <form className="search-form" onSubmit={ handleSubmit(handleSearch) }>
                <div className="row margin">
                    <Field type="text" name="nombre_original" id="nombre_original" 
                        label={ t('screens-document-list-nombre-original') } 
                        component={ renderFieldTwoColumns } 
                        icon="attach_file" 
                        key="nombre_original" 
                    />

                    <Field type="text" name="descripcion" id="descripcion" 
                        label={ t('screens-document-list-descripcion') } 
                        component={ renderFieldTwoColumns } 
                        icon="label_outline" 
                        key="descripcion" 
                    />
                </div>

                <div className="row">
                    <div className="input-field col s12">
                        <FormButton type="submit"
                            title={ t('search-form-button-title') }
                            disabled={ submitting }
                        />

                        <FormButton type="reset"
                            title={ t('reset-form-button-title') }
                            disabled={ submitting }
                            onClick={ handleReset }
                        />
                    </div>
                </div>

            </form>
        );
    };

    return (
        <ul className="collapsible popout collapsible-search-form">
            <li>
                <div className="collapsible-header">
                    <i className="material-icons">tune</i> { t('filter-title') }
                </div>
                <div className="collapsible-body">
                    { renderForm() }
                </div>
            </li>
            
        </ul>
    );
};

const validate = (values) => ({});

export default reduxForm({
    form: 'documentSearchForm',
    validate: validate,
    destroyOnUnmount: false
})(DocumentSearchForm);